export const labels = {
  //Validation
  missingReferenceSheet:
    "‘Reference_sheet’ worksheet를 찾을 수 없습니다. 다시 시도하려면, 신규 workbook에서 EY Canvas 일괄 업데이트 Add-in을 여십시오.",
  descriptionError: "설명이 문자 한도 {0}자를 초과합니다",
  titleMissingError: "제목 누락 (필수)",
  titlemaxLimitError: "제목이 문자 한도 {0}자를 초과합니다",
  userNotFromSelectedGroup:
    "요청은 그룹과 사용자 양쪽에 모두 배정될 수 없습니다",
  dueDateFormatError: "유효하지 않은 만료일 형식",
  fieldError:
    "일부 기록에 오류가 있어 EY Canvas를 업데이트할 수 없습니다. 세부정보는 상태 열을 확인하십시오.",
  invalidColumn: "유효하지 않은 {0} 데이터",
  requiredColumn: "{0} is required",
  hashValueMissing:
    "Hash value needed to update EY Canvas. Check column in this worksheet.",
  // Panel Headers
  engagement: "Engagement",
  select: "선택",
  numberOfRecords: "기록 수",
  dowanloadedOn: "다운로드일",
  canvasUpdatesOn: "처리를 위해 EY Canvas에 전송됨",
  selectRecordsToUpdate: "업데이트할 기록 선택",
  atlasWorkpaperIndexFramework: "EY Atlas: 조서 index 체계",
  referenceOnly: "참조 전용",
  columnsToUpdate: "이 열을 업데이트하십시오",
  dueDateRequired: "만료일 필요",
  requestNotAssignedError: "요청을 그룹 또는 사용자에게 배정하십시오",
  infoText:
    "동일한 workbook에 있는 여러 시트에서 EY Canvas 일괄 업데이트 Add-in을 실행할 수 없습니다. 신규 항목이나 EY Canvas engagement를 편집하려면, 신규 workbook에서 이 도구를 여십시오.",
  noUpdatesSaved: "저장된 업데이트 없음",
  dummyLocalizationText: "더미 로컬본 텍스트",
  unexpectedApiFailure: "예상치 못한 API 실패. 다시 시도하십시오.",
  titleLengthExceeded: "제목이 문자 한도 500자를 초과합니다",
  DescriptionLengthExceeded: "설명이 문자 한도 4,000자를 초과합니다",
  canvasDataEditor: "Canvas 데이터 편집기",
  selectanitemtoedit: "옵션 선택",
  editRequestMessage: "어느 요청사항을 편집하시겠습니까?",
  selectRequestStatus: "요청 상태를 하나 이상 선택하십시오",
  selectRequestErrorMessage: "요청 상태를 하나 이상 선택하십시오",
  sheetWithSameNameExist:
    "이름이 Input_sheet_{0}인 시트가 이미 존재합니다. 계속하려면 시트 이름을 변경하십시오.",
  engagementIdNotFound:
    "EY Canvas engagement를 찾을 수 없습니다. Engagement ID를 확인하여 EY Canvas engagement 열기 권한이 있는지 확인하십시오.",
  boundSheetAlreadyExist_1: "EY Canvas 일괄 업데이트 Add-in",
  boundSheetAlreadyExist_2: "은(는) 이 탭에서 작동하지 않습니다",
  selectAnOperation: "무엇을 하고 싶습니까?",
  submit: "제출",
  next: "다음",
  eyCanvasEngagement: "Engagement 선택",
  search: "검색",
  engagementNotSelected: "Engagement 선택",
  invalidEngagement: "Select a valid engagement",
  back: "뒤로",
  noRecordsFound: "기록을 찾을 수 없습니다",
  masterSheetNoteText:
    "Note: 이 시트에는 EY Canvas 일괄 업데이트 Add-in을 사용해야 합니다",
  informationText: "이 도구를 활용하면 다음을 수행할 수 있습니다:",
  infoText1: "Index를 표준화하기 위해 EY Canvas 문서와 task 이름을 편집하고",
  infoText3: "EY Canvas에서 다른 항목을 생성 및 편집하십시오",
  infoTextforonlyAddClientRequest: "고객 요청사항을 생성하십시오",
  yes: "예",
  no: "아니오",
  close: "닫기",
  ownedByEngagement: "이 engagement에서 소유함",
  sharedToEngagement: "이 engagement에 공유됨",
  status: "상태",
  statusId: "상태 ID",
  Continue: "계속",
  updateCanvas: "EY Canvas 업데이트",
  newDocumentName: "신규 문서 이름",
  documentName: "문서 이름",
  fileExt: "파일 확장자",
  shared: "공유됨",
  docId: "문서 ID",
  hash: "해시",
  newPrefix: "신규 prefix",
  newSuffix: "신규 suffix",
  newTitle: "신규 제목",
  taskPrefix: "Task prefix",
  taskSuffix: "Task suffix",
  taskTitle: "제목",
  taskType: "Task 유형",
  taskTitleEditable: "Task 제목 편집 가능",
  auditPhase: "감사 단계",
  milestone: "Milestone",
  timePhase: "시기",
  taskId: "Task ID",
  populateMsg: "EY Canvas로부터 기록 채우는 중",
  updatingCanvas:
    "EY Canvas 업데이트 중. <br /> 이 작업은 몇 분 정도 걸릴 수 있습니다.",
  loadingContent: "내용 로딩 중",
  filenameRequired: "파일 이름은 필수입니다",
  excelError: "Excel 수식 오류. 수정 후 다시 시도하십시오.",
  specialCharacters: "문서 이름에는 */:<>\\?|" + '"',
  sameDocumentNameError: "신규 문서와 기존 문서의 이름이 같습니다",
  docNameLimit: "문서 이름은 115자를 초과할 수 없습니다",
  markValueInvalid:
    "‘EY Canvas 업데이트’ 내 유효하지 않은 값. 수정 후 다시 시도하십시오.",
  docAndHashNull:
    "EY Canvas를 업데이트하려면 문서 ID 및/또는 해시 값이 필요합니다. 이 워크시트에서 해당 열을 확인하십시오.",
  help: "지원",
  entityNotSelected: "계속하려면 옵션을 선택하십시오",
  AssignedToGroupInputMessageTitle: "그룹을 선택하십시오 (선택사항)",
  AssignedToGroupInputMessageDescription:
    "전체 그룹에 배정하려면 그룹을 선택하고 다음 열을 비워 두십시오",
  AssignedToUserInputMessageTitle: "사용자를 선택하십시오 (선택사항)",
  AssignedToUserInputMessageDescription:
    "특정 사용자에게 배정하려면 사용자를 선택하고 이전 열을 비워 두십시오. 사용자는 그룹별로 열거되어 있습니다.\n\nNote: 모든 그룹 멤버가 이 요청을 볼 수 있습니다. 사용자가 여러 그룹에 속해 있다면, 올바른 드롭다운 옵션을 선택하고 있는지 확인하십시오.",
  apiServerExceptionError:
    "EY Canvas 연결 중 오류가 발생했습니다. 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
  taskNameExceedsLimit:
    "문자 한도를 초과했습니다 (제목: 500자, prefix/suffix: 50자)",
  taskTypeUpdateNotAllowed: "이 task 유형은 task 제목을 편집할 수 없습니다",
  taskEmptyHashOrDocId:
    "EY Canvas를 업데이트하려면 task ID 및/또는 해시 값이 필요합니다. 이 워크시트에서 해당 열을 확인하십시오.",
  taskTitleRequiredError: "Task 제목은 필수입니다",
  sameTaskNameError:
    "신규 및 이전 task 이름(prefix, suffix, 제목)이 동일합니다",
  universalUserPreferenceGetError:
    "EY Canvas 연결 중 사용자 기본 설정 오류가 발생했습니다. 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
  sameWorkbookMultipleSessionsError:
    "동일한 워크북에서 여러 편집 세션을 실행할 수 없습니다. 신규 항목이나 EY Canvas engagement를 편집하려면, 신규 워크북에서 이 도구를 여십시오.",
  errorMessageOnExcelUpdate:
    "일부 기록에 오류가 발생하여 EY Canvas를 업데이트할 수 없습니다. 세부정보는 <b>상태</b> 열을 확인하십시오.",
  insufficientPermissionsError:
    "권한 미비. EY Canvas engagement를 열 수 있는지 확인하고 다시 시도하십시오.",
  ApiValidationErrorPreConditionFailedDocument:
    "EY Canvas를 업데이트할 수 없습니다. 일부 문서가 제거되거나 삭제되었을 수 있습니다. 신규 워크북에서 데이터를 다시 로딩하고 다시 시도하십시오.",
  ApiValidationFailedWithErrorDocument:
    "일부 문서에 오류가 발생하여 EY Canvas를 업데이트할 수 없습니다. 세부정보는 상태 열을 확인하십시오.",
  apiServerConnectError:
    "EY Canvas에 연결할 수 없습니다. 이 engagement를 편집하려면 EY 네트워크에 있어야 할 수 있습니다. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
  apiServerError:
    "EY Canvas 연결 중 오류가 발생했습니다. 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",
  duplicateDocumentNameError: "중복 문서 이름",
  APIValidationError:
    "EY Canvas에서 일부 기록을 업데이트할 수 없습니다. 세부정보는 <b>상태</b> 열을 확인하십시오.",
  excelPopulatingMessage:
    "Excel 채우는 중. 이 작업은 몇 분 정도 걸릴 수 있습니다. 데이터 로드를 마칠 때까지 Excel worksheet를 클릭하지 마십시오.",
  generalError:
    "오류가 발생했습니다. EY Canvas 일괄 업데이트 Add-in을 다시 로드한 후 다시 시도하십시오.",
  boundSheetAlreadyPopulated:
    "이 workbook에서 다른 EY Canvas 일괄 업데이트 Add-in 세션이 이미 시작됐습니다. 신규 workbook에서 다시 시도하십시오.",
  excelRenderIssue:
    "귀하가 Excel workseet를 클릭했을 때 EY Canvas에서 데이터 로드가 중단됐습니다. 다시 시도하려면, 신규 workbook에서 EY Canvas Excel Add-in을 시작하십시오.",
  offlineModeLoadingMessage:
    "EY Canvas Excel Add-in 여는 중. 이 작업은 몇 분 정도 걸릴 수 있습니다. 데이터 로드를 마칠 때까지 Excel worksheet를 클릭하지 마십시오.",
  offlineModeUserClickError:
    "귀하가 Excel workseet를 클릭하여 EY Canvas 일괄 업데이트 Add-in 열기가 중단됐습니다. 다시 시도하려면, EY Canvas 일괄 업데이트 Add-in을 닫았다가 다시 여십시오.",
  inActiveWorkbookError:
    "EY Canvas 일괄 업데이트 Add-in에서 오류가 발생했습니다. 신규 workbook을 열어 다시 시도하십시오. 향후 이 오류를 예방하려면, 데이터가 채워지는 동안 workbook를 전환하지 마십시오.",
  clientRequestTitleMissing: "제목 누락 (필수)",
  addclinetRequestTagError:
    "EY Canvas에 요청이 생성됐지만 태그는 추가할 수 없습니다. EY Canvas에서 수동으로 태그를 추가할 수 있습니다.",
  editclinetRequestTagError:
    "이 요청에 대한 태그를 편집할 수 없습니다. EY Canvas에서 수동으로 태그를 추가하거나 제거할 수 있습니다.",
  clinetRequestEYContactError:
    "이 요청을 위한 EY 연락처를 편집할 수 없습니다. EY Canvas에서 수동으로 EY 연락처를 추가하거나 제거할 수 있습니다.",
  forbiddenByEYError:
    "수행한 작업은 EY 정보 보안에 의해 금지됐습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
  genericErrorMessage:
    "EY Canvas 일괄 업데이트 Add-in에서 오류가 발생했습니다. 신규 workbook을 열고 다시 시도하십시오.",
  itgcName: "ITGC name (required)",
  misstatementIndex: "Misstatement index (required)",
  misstatementDescription: "Misstatement description (required)",
  misstatementId: "Misstatement ID",
  controlName: "Control name (required)",
  frequency: "Frequency",
  designEffectiveness: "Design effectiveness",
  controlType: "Control type",
  controlId: "Control ID",
  operatingEffectiveness: "Operating effectiveness",
  testing: "Testing",
  itControlId: "IT Control ID",
  isControlLowerRisk: "Is control lower risk?",
  timePhaseName: "Time phase name (required)",
  milestoneRequired: "Milestone (required)",
  startDate: "Start date (YYYY-MM-DD) (required)",
  endDate: "End date (YYYY-MM-DD) (required)",
  keyEvent: "Key event",
  timePhaseId: "시기 ID",
  startDateFormatError: "Invalid date format in Start date",
  endDateFormatError: "Invalid date format in End date",
  deficiencyTitle: "Deficiency title (required)",
  deficiencyDescription: "Deficiency description (required)",
  deficiencyTitleOriginal: "Deficiency title",
  deficiencyDescriptionOriginal: "Deficiency description",
  deficiencyCategory: "Category",
  deficiencyId: "Deficiency ID",
  deficiencyTitleMaxLimitError: "Deficiency title exceeds 100 character limit",
  deficiencyTitleRequiredError: "Deficiency title is required",
  deficiencyDescriptionMaxLimitError:
    "Deficiency description exceeds 4000 character limit",
  deficiencyDescriptionRequiredError: "Deficiency description is required",
  invalidDeficiencyId: "Invalid Deficiency ID",
  prefix: "Prefix",
  suffix: "Suffix",
  requiredTitle: "제목 (필수)",
  timePhaseRequired: "시기 (필수)",
  taskGroupRequired: "Task 그룹 (필수)",
  taskGroups: "Task 그룹",
  customizedDescription: "수정된 설명",
  customizedDescriptionRequired: "수정된 설명 (필수)",
  picSignOffRequired: "PIC sign-off",
  eqrSignOffRequired: "EQR sign-off",
  invalidDataInTags: "유효하지 않은 태그 데이터",
  taskTags: "태그",
  editTaskAPIError:
    "이 task에 대한 태그를 편집할 수 없습니다. EY Canvas에서 태그를 수동으로 추가하거나 제거할 수 있습니다.",
  engagementLDCVersionUpdateError:
    "EY Canvas 일괄 업데이트 Add-in을 업데이트할 수 있습니다. 신규 workbook에서 add-in을 열어 task 이름 변경사항을 저장하십시오.",
  module: "모듈",
  titleForMultiSelectInputMessage: "복수 선택 드롭다운",
  descriptionForMultiSelectInputMessage:
    "오른쪽에 있는 add-in 창을 사용하여 드롭다운 옵션을 하나 이상 선택하십시오",
  errorBoundaryMessage:
    "An error has occurred. Please refresh the page and try again. If the issue persists, contact the Help Desk.",
};

// export const instructionSheet={
//  headers:['#','Field Name', 'Additional instructions','To upload as Draft', 'To send to client']

//  }

export const instructionSheetHeader = {
  // reference sheet columns
  count: "#",
  fieldName: "필드 이름",
  additionalInstructions: "추가 지침",
  toUploadAsDraft: "초안 업로드하기",
  toSaveAsDraft: "초안 저장하기",
  toSendToClient: "고객에게 보내기",
  bulkUpdateAddIn: "EY Canvas 일괄 업데이트 Add-in",
  purpose: "목적",
  guidance: "Guidance",
  overView: "필드 개요",
  required: "필수",
};

export const instructionSheetDataForEditClient = {
  purpose:
    "이 도구는 EY Canvas 공동작업에서 고객 요청사항을 일괄 편집할 때 사용할 수 있습니다",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "EY Canvas 공동작업에서 요청사항을 일괄 편집하는 방법과 전송하는 방법 등 EY Canvas 공동작업 사용법에 관한 추가 guidance는 EY Atlas 링크를 참조하십시오",
  additionalInfo:
    "\u00B9 이것은 복수 선택 드롭다운 필드입니다. 이 필드를 편집하려면, 오른쪽에 있는 add-in 창에서 드롭다운을 사용하십시오.",
  bulkUpdate: "\u00B2 추가 지침을 참고하십시오",
};
export const instructionSheetDataForAddTaskOST = {
  purpose:
    "이 도구는 EY Canvas에 신규 task(OST)를 일괄 업로드하는 데 사용할 수 있습니다",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "EY Canvas에서 task를 일괄 배정하는 방법 등 EY Canvas 내 Task 배정에 관한 추가 guidance는 EY Atlas 링크를 참조하십시오",
  additionalInfo:
    "\u00B9 이것은 복수 선택 드롭다운 필드입니다. 이 필드를 편집하려면, 오른쪽에 있는 add-in 창에서 드롭다운을 사용하십시오.",
};
export const instructionSheetDataForEditTasks = {
  purpose: "EY Canvas에서 task를 일괄 편집하는 데 이 도구를 사용할 수 있습니다",
  guidanceHyperlinkforStandardizedIndexing: "Index 표준화",
  guidanceforStandardizedIndexing:
    "Task에 대한 Index 표준화를 촉진하는 데 이 도구를 사용할 수 있습니다. Index 표준화 세부정보는 EY Atlas guidance 링크를 참조하십시오.",
  guidanceHyperlinkForTaskAssignments: "Task 배정",
  guidanceForTaskAssignments:
    "EY Canvas에서 task를 일괄 배정하는 방법 등 EY Canvas 내 task 배정에 관한 추가 guidance는 EY Atlas 링크를 참조하십시오",
  additionalInfo:
    "\u00B9 이것은 복수 선택 드롭다운 필드입니다. 이 필드를 편집하려면, 오른쪽에 있는 add-in 창에서 드롭다운을 사용하십시오.",
};
export const instructionSheetTabularDataForEditTasks = [
  {
    count: "1",
    fieldName: "EY Canvas 업데이트",
    additionalInstructions:
      "Add-in에서 ‘EY Canvas 업데이트’ 버튼을 클릭하면: \r\n - ‘예’는 EY Canvas로 보내는 목록에 기록을 포함시킬 것입니다 \r\n - '아니오’는 EY Canvas로 보내는 목록에 기록을 제외시킬 것입니다",
    required: "예",
  },
  {
    count: "2",
    fieldName: "Prefix",
    additionalInstructions:
      "Index를 표준화하기 위한 명명 규칙을 지원하도록 prefix를 사용하십시오 (문자 한도 50자)",
    required: "아니오",
  },
  {
    count: "3",
    fieldName: "제목",
    additionalInstructions:
      "Task을 효율적으로 관리할 수 있도록 명명 규칙을 수립하십시오 (문자 한도 500자)",
    required: "예",
  },
  {
    count: "4",
    fieldName: "Suffix",
    additionalInstructions: "문자 한도 50자",
    required: "아니오",
  },
  {
    count: "5",
    fieldName: "시기",
    additionalInstructions:
      "프로젝트를 효율적으로 관리할 수 있도록 시기에 task를 배정하십시오",
    required: "예",
  },
  {
    count: "6",
    fieldName: "Task 그룹",
    additionalInstructions:
      "관리 가능한 task 그룹에 감사 작업을 구성하십시오. Task 그룹은 OST에 대해서만 편집할 수 있습니다.",
    required: "예",
  },
  {
    count: "7",
    fieldName: "수정된 설명",
    additionalInstructions: "이 task에 대해 수행할 절차를 설명하십시오",
    required: "아니오",
  },
  {
    count: "8",
    fieldName: "태그 \u00B9",
    additionalInstructions:
      "태그는 EY Canvas에서 task를 관리하는 데 지원 가능한 사용자지정 레이블입니다",
    required: "아니오",
  },
  {
    count: "9",
    fieldName: "PIC sign-off",
    additionalInstructions:
      "Task에 PIC sign-off가 필요한지 표시하십시오. (PIC sign-off가 Knowledge에서 지정되었다면 편집할 수 없습니다.)",
    required: "아니오",
  },
  {
    count: "10",
    fieldName: "EQR sign-off",
    additionalInstructions:
      "Task에 EQR sign-off가 필요한지 표시하십시오. (EQR sign-off가 Knowledge에서 지정되었다면 편집할 수 없습니다.)",
    required: "아니오",
  },
];

export const instructionSheetTabularDataForEditClient = [
  {
    count: "1",
    fieldName: "EY Canvas 업데이트",
    additionalInstructions:
      "Add-in에서 ‘EY Canvas 업데이트’ 버튼을 클릭하면: \r\n - ‘예’는 EY Canvas로 보내는 목록에 요청을 포함시킬 것입니다 \r\n - '아니오’는 EY Canvas로 보내는 목록에 요청을 제외시킬 것입니다",
    toSaveAsDraft: "예",
    toSendToClient: "N/A",
  },
  {
    count: "2",
    fieldName: "제목",
    additionalInstructions:
      "모든 요청사항을 효율적으로 관리할 수 있도록 명명 규칙을 수립하십시오",
    toSaveAsDraft: "예",
    toSendToClient: "예",
  },
  {
    count: "3",
    fieldName: "설명",
    additionalInstructions: "설명 문자 한도는 4,000자입니다",
    toSaveAsDraft: "아니요",
    toSendToClient: "아니요",
  },
  {
    count: "4",
    fieldName: "담당자 (그룹)",
    additionalInstructions:
      "요청을 외부 사용자 또는 그룹에 배정하십시오. \r\n -그룹에 배정하려면, 담당자(그룹)에서 선택하고 다음 열을 비워 두십시오.\r\n - 특정 사용자에게 배정하려면, 사용자를 선택하고 이전 열을 비워 두십시오. 사용자는 그룹별로 열거됩니다.\r\n \r\n Note: 모든 그룹 멤버는 요청을 볼 수 있습니다. 사용자가 여러 그룹에 속해 있는 경우, 올바른 드롭다운 옵션을 선택했는지 확인하십시오.",
    toSaveAsDraft: "아니요",
    toSendToClient: "이 중 하나는 필수입니다",
  },
  {
    count: "5",
    fieldName: "담당자 (사용자)",
    additionalInstructions: "",
    toSaveAsDraft: "아니요",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "만료일 (YYYY-MM-DD)",
    additionalInstructions:
      "만료일은 YYYY-MM-DD 형식으로 지정해야 합니다. 만료일을 지정하지 않고 시기를 선택한 경우, 만료일은 시기의 종료일로 기본 설정됩니다.",
    toSaveAsDraft: "아니요",
    toSendToClient: "예 \u00B2",
  },
  {
    count: "7",
    fieldName: "EY 연락처 \u00B9",
    additionalInstructions:
      "외부 사용자가 질문이 있는 경우 연락할 수 있는 EY 연락처를 추가하십시오. 고객이 요청에 응답하면 EY 연락처는 알림을 받게 됩니다.",
    toSaveAsDraft: "아니요",
    toSendToClient: "아니요",
  },
  {
    count: "8",
    fieldName: "태그 \u00B9",
    additionalInstructions:
      "태그는 공동작업에서 요청을 관리하는 데 지원 가능한 사용자지정 레이블입니다. 팀이 적용한 태그와 외부 사용자가 적용한 태그를 볼 수 있습니다. 태그는 공동작업과 EY Canvas Client Portal 간에 자동으로 동기화됩니다.",
    toSaveAsDraft: "아니요",
    toSendToClient: "아니요",
  },
  {
    count: "9",
    fieldName: "우선순위",
    additionalInstructions:
      "고객이 요청사항 우선순위을 정할 수 있도록, 요청 우선순위를 High 또는 Critical로 설정하십시오. 지정되지 않은 경우, 요청 우선순위는 Normal로 기본 설정됩니다.",
    toSaveAsDraft: "아니요",
    toSendToClient: "예 \u00B2",
  },
  {
    count: "10",
    fieldName: "시기",
    additionalInstructions: "시기 및/또는 만료일을 선택하십시오 (위 참고)",
    toSaveAsDraft: "아니요",
    toSendToClient: "아니요",
  },
];

export const instructionSheetData = {
  purpose:
    "이 도구는 EY Canvas 공동작업에 신규 고객 요청사항을 일괄 업로드하는 데 사용할 수 있습니다. 요청사항은 '초안' 상태로 업로드됩니다. 그러고 나서 EY Canvas 공동작업에서 고객에게 요청사항을 일괄 전송할 수 있습니다.",
  guidanceHyperlink: "EY Atlas",
  //  guidanceHyperlink:"<a 'href=https://live.atlas.ey.com/#document/1146470?pref=20052/9/1007&crumb=11'>EY Atlas</a>",
  guidance:
    "EY Canvas 공동작업에서 요청사항을 일괄 편집하는 방법과 전송하는 방법 등 EY Canvas 공동작업 사용법에 관한 추가 guidance는 EY Atlas 링크를 참조하십시오",
  additionalInfo: "추가 지침을 참고하십시오",
  bulkUpdate:
    "\u00B9 이것은 복수 선택 드롭다운 필드입니다. 이 필드를 편집하려면, 오른쪽에 있는 add-in 창에서 드롭다운을 사용하십시오.",
};

export const instructionSheetTabularData = [
  {
    count: "1",
    fieldName: "EY Canvas 업데이트",
    additionalInstructions:
      "Add-in에서 ‘EY Canvas 업데이트’ 버튼을 클릭하면: \r\n - ‘예’는 EY Canvas로 보내는 목록에 요청을 포함시킬 것입니다 \r\n - '아니오’는 EY Canvas로 보내는 목록에 요청을 제외시킬 것입니다",
    toUploadAsDraft: "예",
    toSendToClient: "N/A",
  },
  {
    count: "2",
    fieldName: "제목 (필수)",
    additionalInstructions:
      "모든 요청사항을 효율적으로 관리할 수 있도록 명명 규칙을 수립하십시오",
    toUploadAsDraft: "예",
    toSendToClient: "예",
  },
  {
    count: "3",
    fieldName: "설명",
    additionalInstructions: "설명 문자 한도는 4,000자입니다",
    toUploadAsDraft: "아니오",
    toSendToClient: "아니요",
  },
  {
    count: "4",
    fieldName: "담당자 (그룹)",
    additionalInstructions:
      "요청을 외부 사용자 또는 그룹에 배정하십시오. \r\n -그룹에 배정하려면, 담당자(그룹)에서 선택하고 다음 열을 비워 두십시오.\r\n - 특정 사용자에게 배정하려면, 사용자를 선택하고 이전 열을 비워 두십시오. 사용자는 그룹별로 열거됩니다.\r\n \r\n Note: 모든 그룹 멤버는 요청을 볼 수 있습니다. 사용자가 여러 그룹에 속해 있는 경우, 올바른 드롭다운 옵션을 선택했는지 확인하십시오.",
    toUploadAsDraft: "아니오",
    toSendToClient: "이 중 하나는 필수입니다",
  },
  {
    count: "5",
    fieldName: "담당자 (사용자)",
    additionalInstructions: "",
    toUploadAsDraft: "아니오",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "만료일 (YYYY-MM-DD)",
    additionalInstructions:
      "만료일은 YYYY-MM-DD 형식으로 지정해야 합니다. 만료일을 지정하지 않고 시기를 선택한 경우, 만료일은 시기의 종료일로 기본 설정됩니다.",
    toUploadAsDraft: "아니오",
    toSendToClient: "예 \u00B2",
  },
  {
    count: "7",
    fieldName: "EY 연락처 \u00B9",
    additionalInstructions:
      "외부 사용자가 질문이 있는 경우 연락할 수 있는 EY 연락처를 추가하십시오. 고객이 요청에 응답하면 EY 연락처는 알림을 받게 됩니다.",
    toUploadAsDraft: "아니오",
    toSendToClient: "아니요",
  },
  {
    count: "8",
    fieldName: "태그 \u00B9",
    additionalInstructions:
      "태그는 공동작업에서 요청을 관리하는 데 지원 가능한 사용자지정 레이블입니다. 팀이 적용한 태그와 외부 사용자가 적용한 태그를 볼 수 있습니다. 태그는 공동작업과 EY Canvas Client Portal 간에 자동으로 동기화됩니다.",
    toUploadAsDraft: "아니오",
    toSendToClient: "아니요",
  },
  {
    count: "9",
    fieldName: "우선순위",
    additionalInstructions:
      "고객이 요청사항 우선순위을 정할 수 있도록, 요청 우선순위를 High 또는 Critical로 설정하십시오. 지정되지 않은 경우, 요청 우선순위는 Normal로 기본 설정됩니다.",
    toUploadAsDraft: "아니오",
    toSendToClient: "예 \u00B2",
  },
  {
    count: "10",
    fieldName: "시기",
    additionalInstructions: "시기 및/또는 만료일을 선택하십시오 (위 참고)",
    toUploadAsDraft: "아니오",
    toSendToClient: "아니요",
  },
];

export const instructionSheetStaticDataITGC = {
  purpose: "This tool can be used to bulk edit ITGC details in EY Canvas.",
  additionalInfo:
    "\u002A EY Canvas에서 값이 이미 지정됐다면, 변경될 수 있지만 삭제될 수는 없습니다",
};
export const instructionSheetStaticDataMisstatement = {
  purpose:
    "This tool can be used to bulk edit misstatement details in EY Canvas.",
  additionalInfo:
    "\u002A EY Canvas에서 값이 이미 지정됐다면, 변경될 수 있지만 삭제될 수는 없습니다",
};
export const instructionSheetDataForMisstatements = {
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on misstatements and summary of audit differences.",
};
export const instructionSheetTabularDataMisstatement = [
  {
    count: "1",
    fieldName: "EY Canvas 업데이트",
    additionalInstructions:
      "Add-in에서 ‘EY Canvas 업데이트’ 버튼을 클릭하면:\r\n - ‘예’는 EY Canvas로 보내는 목록에 기록을 포함시킬 것입니다 \r\n - '아니오’는 EY Canvas로 보내는 목록에 기록을 제외시킬 것입니다",
    required: "예",
  },
  {
    count: "2",
    fieldName: "Misstatement index",
    additionalInstructions: "Unique identifier for the misstatement (100 character limit)",
    required: "예",
  },
  {
    count: "3",
    fieldName: "Misstatement description",
    additionalInstructions:
      "Description of the misstatement (500 character limit)\n",
    required: "예",
  },
];
export const instructionSheetStaticDataAddTaskOST = {
  purpose:
    "이 도구는 EY Canvas에 신규 task(OST)를 일괄 업로드하는 데 사용할 수 있습니다",
  additionalInfo:
    "\u002A EY Canvas에서 값이 이미 지정됐다면, 변경될 수 있지만 삭제될 수는 없습니다",
};
export const instructionSheetTabularDataForAddTaskOST = [
  {
    count: "1",
    fieldName: "EY Canvas 업데이트",
    additionalInstructions:
      "Add-in에서 ‘EY Canvas 업데이트’ 버튼을 클릭하면: \r\n - ‘예’는 EY Canvas로 보내는 목록에 기록을 포함시킬 것입니다 \r\n - '아니오’는 EY Canvas로 보내는 목록에 기록을 제외시킬 것입니다",
    required: "예",
  },
  {
    count: "2",
    fieldName: "Prefix",
    additionalInstructions:
      "Index를 표준화하기 위한 명명 규칙을 지원하도록 prefix를 사용하십시오 (문자 한도 50자)",
    required: "아니오",
  },
  {
    count: "3",
    fieldName: "제목",
    additionalInstructions:
      "Task을 효율적으로 관리할 수 있도록 명명 규칙을 수립하십시오 (문자 한도 500자)",
    required: "예",
  },
  {
    count: "4",
    fieldName: "Suffix",
    additionalInstructions: "문자 한도 50자",
    required: "아니오",
  },
  {
    count: "5",
    fieldName: "시기",
    additionalInstructions:
      "프로젝트를 효율적으로 관리할 수 있도록 시기에 task를 배정하십시오",
    required: "예",
  },
  {
    count: "6",
    fieldName: "Task 그룹",
    additionalInstructions: "관리가능한 task 그룹에 작업을 구성하십시오",
    required: "예",
  },
  {
    count: "7",
    fieldName: "수정된 설명",
    additionalInstructions: "이 task에 대해 수행할 절차를 설명하십시오",
    required: "예",
  },
  {
    count: "8",
    fieldName: "태그 \u00B9",
    additionalInstructions:
      "태그는 EY Canvas에서 task를 관리하는 데 지원 가능한 사용자지정 레이블입니다",
    required: "아니오",
  },
  {
    count: "9",
    fieldName: "PIC sign-off",
    additionalInstructions: "해당 task에 PIC sign-off가 필요한지 표시하십시오",
    required: "아니오",
  },
  {
    count: "10",
    fieldName: "EQR sign-off",
    additionalInstructions: "해당 task에 EQR sign-off가 필요한지 표시하십시오",
    required: "아니오",
  },
];
export const instructionSheetStaticDataControl = {
  purpose: "This tool can be used to bulk edit control details in EY Canvas.",
  additionalInfo:
    "\u002AIf a value is already specified in EY Canvas for this field, it can be changed but not deleted.",
};

export const instructionSheetStaticDataTimePhase = {
  purpose:
    "This tool can be used to bulk edit time phases details in EY Canvas.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on the Milestones Program, which promotes effective project management and timely audit pacing. Teams can associate time phases to each milestone to plan completion of audit work by scheduled deadlines and mitigate the potential for undue compression during the year-end reporting cycle.",
};

export const instructionSheetTabularDataTimePhase = [
  {
    count: "1",
    fieldName: "EY Canvas 업데이트",
    additionalInstructions:
      "Add-in에서 ‘EY Canvas 업데이트’ 버튼을 클릭하면: \r\n - ‘예’는 EY Canvas로 보내는 목록에 기록을 포함시킬 것입니다 \r\n - '아니오’는 EY Canvas로 보내는 목록에 기록을 제외시킬 것입니다",
    required: "예",
  },
  {
    count: "2",
    fieldName: "시기 이름",
    additionalInstructions: "500 character limit",
    required: "예",
  },
  {
    count: "3",
    fieldName: "Milestone",
    additionalInstructions: "Select a milestone from the drop-down list",
    required: "예",
  },
  {
    count: "4",
    fieldName: "시작일",
    additionalInstructions: "Must be specified in YYYY-MM-DD format",
    required: "예",
  },
  {
    count: "5",
    fieldName: "종료일",
    additionalInstructions: "Must be specified in YYYY-MM-DD format",
    required: "예",
  },
  {
    count: "6",
    fieldName: "Key event",
    additionalInstructions:
      "Indicate if this milestone is a key event in the completion of audit work",
    required: "아니오",
  },
];

export const instructionSheetTabularDataITGC = [
  {
    count: "1",
    fieldName: "EY Canvas 업데이트",
    additionalInstructions:
      "Add-in에서 ‘EY Canvas 업데이트’ 버튼을 클릭하면: \r\n - ‘예’는 EY Canvas로 보내는 목록에 기록을 포함시킬 것입니다 \r\n - '아니오’는 EY Canvas로 보내는 목록에 기록을 제외시킬 것입니다",
    required: "예",
  },
  {
    count: "2",
    fieldName: "ITGC name (required)",
    additionalInstructions: "ITGC name has a 500 character limit",
    required: "예",
  },
  {
    count: "3",
    fieldName: "Frequency",
    additionalInstructions:
      "Select a control frequency from the drop-down list",
    required: "No\u002A",
  },
  {
    count: "4",
    fieldName: "Design effectiveness",
    additionalInstructions:
      "If design effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective)",
    required: "아니오",
  },
  {
    count: "5",
    fieldName: "Operating effectiveness",
    additionalInstructions:
      "If operating effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective)",
    required: "아니오",
  },
  {
    count: "6",
    fieldName: "Testing",
    additionalInstructions: "Indicate if we plan to test this control",
    required: "아니오",
  },
];

export const instructionSheetTabularDataControl = [
  {
    count: "1",
    fieldName: "EY Canvas 업데이트",
    additionalInstructions:
      "Add-in에서 ‘EY Canvas 업데이트’ 버튼을 클릭하면: \r\n - ‘예’는 EY Canvas로 보내는 목록에 기록을 포함시킬 것입니다 \r\n - '아니오’는 EY Canvas로 보내는 목록에 기록을 제외시킬 것입니다",
    required: "예",
  },
  {
    count: "2",
    fieldName: "Control name (required)",
    additionalInstructions: "Control name has a 500 character limit",
    required: "예",
  },
  {
    count: "3",
    fieldName: "Frequency",
    additionalInstructions:
      "Select a control frequency from the drop-down list",
    required: "No\u002A",
  },
  {
    count: "4",
    fieldName: "Control type",
    additionalInstructions: "Select a control type from the drop-down list",
    required: "No\u002A",
  },
  {
    count: "5",
    fieldName: "Design effectiveness",
    additionalInstructions:
      "If design effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective)",
    required: "아니오",
  },
  {
    count: "6",
    fieldName: "Operating effectiveness",
    additionalInstructions:
      "If operating effectiveness procedures have been completed, indicate the conclusion (Effective or Ineffective)",
    required: "아니오",
  },
  {
    count: "7",
    fieldName: "Testing",
    additionalInstructions: "Indicate if we plan to test this control",
    required: "아니오",
  },
  {
    count: "8",
    fieldName: "Is control lower risk?",
    additionalInstructions: "Indicate if the control is lower risk",
    required: "아니오",
  },
];

export const errors = {
  14057: "중복 문서 이름",
  14084: "문서 이름에는 */:<>\\?|" + '"',
  14085: "문서 이름은 115자를 초과할 수 없습니다",
  14086: "문서 세부정보 업데이트 중 DocService 실패",
  14088: "중복 문서 이름",
  5166: "이 task 유형은 task 제목을 편집할 수 없습니다",
  5170: "문자 한도를 초과했습니다 (제목: 500자, prefix/suffix: 50자)",
  5169: "문자 한도를 초과했습니다 (제목: 500자, prefix/suffix: 50자)",
  5047: "문자 한도를 초과했습니다 (제목: 500자, prefix/suffix: 50자)",
  5018: "EY Canvas에서 삭제되거나 거절된 task",
  14071: "파일 이름은 필수입니다",
  14054: "파일 이름은 필수입니다",
  409: "중복 문서 이름",
  21071: "본문에서 전송된 고객 요청사항 수가 최대 허용 한도를 초과합니다",
  21041: "제목이 문자 한도 500자를 초과합니다",
  21076: "유효하지 않은 우선순위 데이터",
  21042: "설명이 문자 한도 4,000자를 초과합니다",
  21072: "유효하지 않은 만료일 데이터",
  21027: "제목 누락 (필수)",
  21039: "요청을 유효한 그룹/사용자에게 배정하십시오",
  21032: "요청을 유효한 그룹/사용자에게 배정하십시오",
  21034: "Client Group does not have active users",
  21035: "EY Canvas에서 요청을 찾을 수 없습니다",
  21036: "유효하지 않은 시기 데이터",
  21057:
    "EY 연락처가 engagement 멤버가 아니거나, 활동 상태가 아니거나, 독립성 전용입니다",
  21073:
    "요청 페이로드 데이터가 하나 이상 유효하지 않습니다. 데이터를 확인하고 다시 시도하십시오.",
  21074: "수신된 요청에서 제목, 설명 또는 우선순위를 변경할 수 없습니다",
  21075:
    "수락된 요청사항에 대해 제목, 설명, 담당자 (그룹), 담당자 (사용자), 만료일, 우선순위 또는 시기를 변경할 수 없습니다",
  21076: "우선순위 유형 ID ENUM은 1, 2, 또는 3을 포함하지 않습니다",
  21077: "만료일을 YYYY-MM-DD 형식으로 지정하십시오",
  21078:
    "그룹 담당자나 사용자 담당자를 업데이트할 경우, 그룹과 사용자는 모두 필수입니다",
  21079: "만료일을 YYYY-MM-DD 형식으로 지정하십시오",
  21080: "시기를 사용할 수 있다면, 만료일은 필수입니다",
  21081: "EY 연락처가 유효하지 않거나 중복을 포함하고 있습니다",
  25000: "시기를 지정하십시오",
  26000: "만료일을 YYYY-MM-DD 형식으로 지정하십시오",
  84006: "ITGC 이름은 필수입니다",
  84007: "ITGC 이름이 문자 한도 500자를 초과합니다",
  84008: "유효하지 않은 빈도 데이터",
  84029: "유효하지 않은 빈도 데이터",
  84010: "유효하지 않은 설계 효과성 데이터",
  84027: "유효하지 않은 테스트 데이터",
  84028: "유효하지 않은 테스트 데이터",
  84031: "테스트 = 아니오인 경우 운영 효과성 결론을 내릴 수 없습니다",
  84032: "유효하지 않은 설계 효과성 데이터",
  84004: "유효하지 않은 IT 통제 ID",
  37007: "Misstatement index is required",
  37009: "Misstatement description is required",
  37130: "Misstatement description exceeds 500 character limit",
  37036: "Invalid Misstatement ID",
  37072: "Misstatement index exceeds 100 character limit",
  83018: "통제 이름이 문자 한도 500자를 초과합니다",
  83004: "유효하지 않은 통제 ID",
  83006: "통제 이름은 필수입니다",
  83009: "유효하지 않은 빈도 데이터",
  83010: "유효하지 않은 통제 유형 데이터",
  83031: "유효하지 않은 IPE 수동 테스트 여부 데이터",
  83012: "유효하지 않은 설계 효과성 데이터",
  83033: "유효하지 않은 운영 효과성 데이터",
  83034: "유효하지 않은 테스트 데이터",
  85004: "Invalid Deficiency ID",
  85006: "Deficiency title is required",
  85018: "Deficiency title exceeds 100 character limit",
  85019: "Deficiency description is required",
  85042: "Deficiency description exceeds 4000 character limit",
  5169: "Prefix가 문자 한도 50자를 초과합니다",
  5170: "Suffix가 문자 한도 50자를 초과합니다",
  5047: "제목이 문자 한도 500자를 초과합니다",
  5108: "설명이 문자 한도 4,000자를 초과합니다",
  5059: "유효하지 않은 시기 데이터 (필수)",
  5111: "유효하지 않은 Task 그룹 데이터 (필수)",
  5051: "유효하지 않은 Task 그룹 데이터 (필수)",
  5019: "수정된 설명(필수)은 필수입니다",
  5103: "제목(필수)은 필수입니다",
  5104: "시기(필수)는 필수입니다",
  5109: "Task 그룹(필수)은 필수입니다",
  5203: "PIC sign-off는 필수입니다",
  5204: "EQR sign-off는 필수입니다",
  5202: "Task 그룹을 변경할 수 없습니다",
  5168: "제목(필수)은 필수입니다",
  16003: "Invalid Time phase ID",
  16006: "Invalid data in Time phase name (required)",
  16007: "Invalid data in Milestone",
  16008: "Invalid data in Start date",
  16009: "Invalid data in End date",
  16010: "Time phase name (required) is required",
  16022: "Specify a date later than 1900-01-01",
  16023: "End date must be on or after the Start date",
  16024: "Key event is required",
  16025: "Start date must be on or before the End date",
  16026: "Time phase deleted or not found in EY Canvas",
  16027: "Time phase name exceeds 500 character limit",
  16028: "Milestone (required) is required",
  16029: "Start date (YYYY-MM-DD) (required) is required",
  16030: "End date (YYYY-MM-DD) (required) is required",
};

export const milestonesLabels = {
  1: "범위",
  2: "전략",
  3: "Walkthrough",
  4: "중간 통제 테스트",
  5: "중간 실증 테스트",
  6: "Walkthrough (기말 프로세스)",
  7: "기말 통제 테스트",
  8: "기말 실증 테스트",
  9: "결론",
  10: "해당 없음",
  11: "실행",
  12: "Group audit S&S",
  13: "Preliminary planning",
  14: "CRA",
  15: "Identify and assess risk",
  16: "Design response to risk",
  17: "중간감사 후 프로젝트 관리",
};

export const clientRequestStatusType = {
  1: "초안",
  2: "초안",
  5: "초안",
  10: "초안",
  11: "초안",
  14: "초안",
  17: "초안",
  6: "응답 보류 중",
  9: "응답 보류 중",
  13: "응답 보류 중",
  16: "응답 보류 중",
  20: "응답 보류 중",
  21: "응답 보류 중",
  27: "응답 보류 중",
  7: "수신됨",
  12: "수신됨",
  15: "수신됨",
  18: "수신됨",
  19: "수신됨",
  8: "수락됨",
  28: "수락됨",
};

export const filterAuditPhases = {
  1: "범위 및 전략",
  2: "실행",
  3: "결론",
};

export const taskTypeAbbreviation = {
  1: "TOC",
  2: "TOC",
  3: "TOC",
  4: "TOC",
  5: "TOC",
  6: "TOC",
  7: "RT",
  8: "RT",
  9: "RT",
  10: "RT",
  11: "RT",
  12: "OST",
  13: "OST",
  14: "PST",
  15: "OSP",
  16: "OSP",
  17: "PSP",
  18: "UDP",
  19: "UDP",
  20: "UDP",
  21: "UDP",
  22: "ACT",
  23: "GT",
  24: "GT",
  25: "GT",
  26: "OSP",
  27: "GT",
  28: "UDP",
  29: "EDC",
  30: "UDP",
  31: "UDP",
  32: "EDC",
  34: "RT",
};

export const uploadStatusLabels = {
  1: "동기화 보류 중", //pending
  2: "오프라인에서 편집됨", //offlineEdit
  3: "다운로드됨", //downloaded
  4: "업로드됨", //uploaded
  5: "유효하지 않은 입력", //invalidInput
  6: "서버 오류", //serverError
  7: "예상치 못한 API 오류", //unexpectedAPIError
  8: "고객 가져오기 오류", //clientFetchError
  9: "사후 처리 오류", //postProcessingError
};

export const clientrequestRefSheetMainHeaders = {
  // reference sheet columns
  updateEyCanvas: "EY Canvas 업데이트",
  priority: "우선순위",
  assignedToGroups: "담당자 (그룹)",
  assignedToUsers: "담당자 (사용자)",
  eyContacts: "EY 연락처",
  tags: "태그",
  timephases: "시기",
};

export const OstTaskReferenceSheetColumns = {
  updateEyCanvas: "EY Canvas 업데이트",
  timePhase: "시기",
  taskGroup: "Task 그룹",
  tags: "태그",
  timephasename: "시기 이름",
  startDate: "시작일",
  endDate: "종료일",
  timePhaseId: "시기 ID",
  taskGroupName: "Task 그룹 이름",
  auditPhase: "감사 단계",
  groupName: "그룹 이름",
  taskGroupId: "Task 그룹 ID",
  tagDescription: "설명",
  tagGroup: "태그 그룹",
  tagLabel: "태그",
  tagColor: "색상",
  tagId: "태그 ID",
  signOff: "Sign-off",
  signOffValue: "Sign-off 값",
};

export const clientrequestInputSheetMainHeaders = {
  clientRequestTitle: "제목 (필수)",
  clientRequestDescription: "설명",
  AssignedToGroup: "담당자 (그룹)",
  AssignedToUser: "담당자 (사용자)",
  DueDate: "만료일 (YYYY-MM-DD)",
  eyContact: "EY 연락처",
  tags: "태그",
  priority: "우선순위",
  requestGuid: "고객 요청 GUID",
  requestId: "고객 요청 ID",
  statusID: "상태 ID",
  timephases: "시기",
  requestHash: "요청 #",
  requestHashSpace: "요청 #",
  clientRequestTitleSpace: "제목 (필수)",
  clientRequestDescriptionSpace: "설명",
  AssignedToGroupSpace: "담당자 (그룹)",
  AssignedToUserSpace: "담당자 (사용자)",
  DueDateSpace: "만료일 (YYYY-MM-DD)",
  eyContactSpace: "EY 연락처",
  tagsSpace: "태그",
  prioritySpace: "우선순위",
  timephasesSpace: "시기",
  requestStatusId: "요청 상태 ID",
  requestStatus: "요청 상태",
};

export const clientrequestRefSheetSubHeaders = {
  priority: {
    priorityName: "우선순위 이름",
    priorityTypeId: "우선순위 유형 ID",
  },
  assignedToGroups: {
    group: "그룹",
    groupName: "그룹 이름",
    groupId: "그룹 ID",
  },
  assignedToUsers: {
    groupMember: "그룹 멤버",
    name: "이름",
    groupName: "그룹 이름",
    userId: "사용자 ID",
    groupId: "그룹 ID",
  },
  eyContacts: {
    name: "이름",
    userId: "사용자 ID",
  },
  tags: {
    tagName: "태그",
    colorCode: "색상",
    engagementTagName: "설명",
    engagementTagID: "태그 ID",
  },
  timephases: {
    timePhaseName: "시기",
    periodName: "시기 이름",
    startDate: "시작일",
    dueDate: "종료일",
    timephaseId: "시기 ID",
  },
};

export const priorityTypesCollaboration = [
  {
    value: 1,
    label: "Normal",
  },
  {
    value: 3,
    label: "High",
  },
  {
    value: 4,
    label: "Critical",
  },
];

export const ButtonOptions = [
  {
    label: "문서 이름 편집",
    activeButton: "active-btn",
    id: 1,
    DisplayOrder: 4,
  },
  {
    label: "고객 요청사항 초안 생성",
    activeButton: "active-btn",
    id: 3,
    DisplayOrder: 1,
  },
  {
    label: "고객 요청사항 편집",
    activeButton: "active-btn",
    id: 4,
    DisplayOrder: 2,
  },
  {
    label: "ITGC 편집",
    activeButton: "active-btn",
    id: 5,
    DisplayOrder: 5,
  },
  {
    label: "Task 편집",
    activeButton: "active-btn",
    id: 2,
    DisplayOrder: 8,
  },
  {
    label: "Edit time phases",
    activeButton: "active-btn",
    id: 8,
    DisplayOrder: 9,
  },
  {
    label: "통제 편집",
    activeButton: "active-btn",
    id: 6,
    DisplayOrder: 3,
  },
  {
    label: "Task (OST) 생성",
    activeButton: "active-btn",
    id: 7,
    DisplayOrder: 7,
  },
  {
    label: "Edit misstatements",
    activeButton: "active-btn",
    id: 9,
    DisplayOrder: 6,
  },
  {
    label: "Edit deficiencies",
    activeButton: "active-btn",
    id: 10,
    DisplayOrder: 10,
  },
];

export const ClientRequestTypeOptions = [
  {
    label: "초안",
    id: 1,
    apiPayload: "Draft",
  },
  {
    label: "보류 중 응답",
    id: 2,
    apiPayload: "Pending",
  },
  {
    label: "수신됨",
    id: 3,
    apiPayload: "Received",
  },
  {
    label: "수락됨",
    id: 4,
    apiPayload: "Accepted",
  },
];

export const colorOptionsLabels = [
  {
    value: "빨간색",
    label: "빨간색",
  },
  {
    value: "귤색",
    label: "귤색",
  },
  {
    value: "청록색",
    label: "청록색",
  },
  {
    value: "파란색",
    label: "파란색",
  },
  {
    value: "보라색",
    label: "보라색",
  },
  {
    value: "녹색",
    label: "녹색",
  },
  {
    value: "노란색",
    label: "노란색",
  },
  {
    value: "회색",
    label: "회색",
  },
];

export const controlFrequencyNameTypes = [
  {
    id: 1,
    value: 1,
    label: "하루에 여러 번",
  },
  {
    id: 2,
    value: 2,
    label: "매일",
  },
  {
    id: 3,
    value: 3,
    label: "매주",
  },
  {
    id: 4,
    value: 4,
    label: "매월",
  },
  {
    id: 5,
    value: 5,
    label: "매분기",
  },
  {
    id: 6,
    value: 6,
    label: "매년",
  },
  {
    id: 8,
    value: 8,
    label: "기타",
  },
];

export const controlDesignEffectivenessType = [
  {
    id: 1,
    value: 1,
    label: "효과적",
  },
  {
    id: 2,
    value: 2,
    label: "비효과적",
  },
];

export const operativeEffectivenessType = [
  {
    id: true,
    value: true,
    label: "효과적",
  },
  {
    id: false,
    value: false,
    label: "비효과적",
  },
];

export const BooleanType = [
  {
    id: true,
    value: true,
    label: "true",
  },
  {
    id: false,
    value: false,
    label: "거짓",
  },
];

export const YesNoTypes = [
  {
    id: true,
    value: 1,
    booleanValue: true,
    label: "예",
  },
  {
    id: false,
    value: 0,
    booleanValue: false,
    label: "아니오",
  },
];

export const controlTypes = [
  {
    id: 1,
    value: 1,
    label: "IT Application 통제",
  },
  {
    id: 2,
    value: 2,
    label: "IT 의존 수동 통제",
  },
  {
    id: 3,
    value: 3,
    label: "수동 예방",
  },
  {
    id: 4,
    value: 4,
    label: "수동 적발",
  },
];

// Mirrors filterMilestones in EY Canvas web: ordered the way EY Canvas displays milestones rather than by id,
// omitting Scope (1), Strategy (2) and "No milestone" (0) because EY Canvas hides those from this dropdown.
export const timephaseTypes = [
  {
    id: 12,
    value: 12,
    label: "Group audit S&S",
  },
  {
    id: 13,
    value: 13,
    label: "Preliminary planning",
  },
  {
    id: 14,
    value: 14,
    label: "CRA",
  },
  {
    id: 15,
    value: 15,
    label: "Identify and assess risk",
  },
  {
    id: 16,
    value: 16,
    label: "Design response to risk",
  },
  {
    id: 17,
    value: 17,
    label: "중간감사 후 프로젝트 관리",
  },
  {
    id: 3,
    value: 3,
    label: "Walkthrough",
  },
  {
    id: 4,
    value: 4,
    label: "중간 통제 테스트",
  },
  {
    id: 5,
    value: 5,
    label: "중간 실증 테스트",
  },
  {
    id: 6,
    value: 6,
    label: "Walkthrough (기말 프로세스)",
  },
  {
    id: 7,
    value: 7,
    label: "기말 통제 테스트",
  },
  {
    id: 8,
    value: 8,
    label: "기말 실증 테스트",
  },
  {
    id: 11,
    value: 11,
    label: "실행",
  },
  {
    id: 9,
    value: 9,
    label: "결론",
  },
  {
    id: 10,
    value: 10,
    label: "N/A",
  },
];

export const deficiencyCategoryTypes = [
  {
    id: 19,
    value: 19,
    label: "Business process",
  },
  {
    id: 34,
    value: 34,
    label: "IT process",
  },
];
